/**
 * Module summary:
 * This atomic card component provides a reusable container with configurable
 * padding, shadow, and hover styling so larger screens can compose consistent
 * surfaces without repeating wrapper markup.
 */

import React from 'react';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
}

/**
 * Atomic Card Component
 * Container for grouping related content
 */
export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  shadow = 'md',
  hover = false
}) => {
  // Build the card class list from the chosen visual options so callers can use simple props instead of manual classes.
  const baseClasses = 'card';
  const paddingClass = `card--padding-${padding}`;
  const shadowClass = `card--shadow-${shadow}`;
  const hoverClass = hover ? 'card--hover' : '';
  
  const classes = [baseClasses, paddingClass, shadowClass, hoverClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default Card;
